import { useState } from 'react';

import { User, UserReplacement } from '@Types/index';
import EmployeeSelect from '@Components/EmployeeSelector/EmployeeSelect';
import useReassignUsersManager from '@Hooks/useReassignUsersManager';
import { useReassignMutation } from '@Store/api/approvalsListApiSlice';
import RequiredNotification from '@Components/RequiredNotification/RequiredNotification';
import { useAppSelector } from '@Hooks/index';
import { currentUserSelector } from '@Store/selectors/userInfoSelector';

interface ReassignWindowProps {
  isOpen: boolean;
  onClose: () => void;
  onUserSelected: () => void;
  taskId: string;
  creatorRequestNumber: string;
}

const ReassignWindow: React.FC<ReassignWindowProps> = ({
  isOpen,
  onClose,
  onUserSelected,
  taskId,
  creatorRequestNumber,
}) => {
  const currentUser = useAppSelector(currentUserSelector);
  const [showNotification, setShowNotification] = useState(false);
  const [chosenUser, setChosenUser] = useState<UserReplacement | null>(null);

  const [reassign] = useReassignMutation();
  const { reassignUsers, onLoadMore, onSearch } = useReassignUsersManager({
    empNumber: currentUser?.empNumber,
    creatorRequestNumber,
  });

  const openNotification = (): void => setShowNotification(true);
  const closeNotification = (): void => setShowNotification(false);

  const performReassign = (): void => {
    closeNotification();

    if (chosenUser) {
      reassign({ taskId, assigneeId: chosenUser.empNumber })
        .unwrap()
        .then(() => {
          onUserSelected();
        })
        .catch(() => {});
    }
  };

  const handleSelectUser = (
    selectedUser: User | UserReplacement | null
  ): void => {
    if (selectedUser) {
      setChosenUser(selectedUser as UserReplacement);

      openNotification();
    }
  };

  const handleSearch: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const searchString = event.target.value;
    onSearch(searchString);
  };

  return (
    <>
      <EmployeeSelect
        title="Re Assign"
        isOpen={isOpen}
        onClose={onClose}
        onSearchChange={handleSearch}
        onUserSelect={handleSelectUser}
        users={reassignUsers || []}
        onLoadMore={onLoadMore}
      />
      <RequiredNotification
        title="Re-Assign"
        message="Are you sure you want to Re-Assign request?"
        isModalOpen={showNotification}
        textSuccessBtn="Yes"
        textCancelBtn="No"
        handleCancel={closeNotification}
        handleSuccess={performReassign}
      />
    </>
  );
};

export default ReassignWindow;
